import React from 'react';
import { FaShieldAlt, FaUserShield, FaServer, FaGlobe, FaEnvelope, FaLock, FaArrowLeft } from 'react-icons/fa';
import '../assets/styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-wrapper">
      <div className="privacy-policy-container">
        <div className="privacy-header">
          <div className="privacy-icon-wrapper">
            <FaShieldAlt className="privacy-icon" />
          </div>
          <div className="privacy-title">
            <h1>Privacy Policy & Data Protection Notice</h1>
            <div className="company-info">A product of SalpTech</div>
          </div>
        </div>

        <div className="last-updated">Last updated: March 1, 2025</div>

        <div className="privacy-section">
          <h2>1. Data Controller</h2>
          <p>
            As Investor Investor Startup Driver platform, owned and operated by SalpTech, we act as a data controller under the General Data Protection Regulation (GDPR) and other applicable data protection laws. This privacy notice explains how we process and protect your personal data and outlines your rights.
          </p>
        </div>

        <div className="privacy-section">
          <h2>2. Personal Data We Collect</h2>
          
          <div className="data-category">
            <div className="data-icon-container">
              <FaUserShield className="data-icon" />
            </div>
            <div className="data-content">
              <h3>Initiative Information</h3>
              <ul>
                <li>Initiative name</li>
                <li>Sector information</li>
                <li>Development stage</li>
                <li>Market condition assessment</li>
              </ul>
            </div>
          </div>

          <div className="data-category">
            <div className="data-icon-container">
              <FaServer className="data-icon" />
            </div>
            <div className="data-content">
              <h3>Financial Metrics</h3>
              <ul>
                <li>Total investment amount</li>
                <li>Monthly Recurring Revenue (MRR)</li>
                <li>Burn Rate</li>
                <li>Churn Rate</li>
                <li>Last Twelve Months (LTM) revenue</li>
                <li>Lifetime Value (LTV)</li>
                <li>Customer Acquisition Cost (CAC)</li>
              </ul>
            </div>
          </div>

          <div className="data-category">
            <div className="data-icon-container">
              <FaGlobe className="data-icon" />
            </div>
            <div className="data-content">
              <h3>Assessment Responses</h3>
              <p>Your responses to assessment questions on the platform.</p>
            </div>
          </div>
        </div>

        <div className="privacy-section">
          <h2>3. Purposes of Data Processing</h2>
          <p>Your personal data is processed for the following purposes:</p>
          <ul>
            <li>Evaluating and analyzing your startup</li>
            <li>Providing customized services and recommendations</li>
            <li>Conducting sectoral and statistical analyses</li>
            <li>Improving and developing the platform</li>
            <li>Fulfilling legal obligations</li>
            <li>Carrying out communication activities</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>4. Legal Basis for Processing</h2>
          <p>The legal bases for processing your personal data are:</p>
          <ul>
            <li>Your explicit consent (GDPR Art. 6(1)(a))</li>
            <li>Performance of a contract to which you are party (GDPR Art. 6(1)(b))</li>
            <li>Legitimate interests pursued by the data controller (GDPR Art. 6(1)(f))</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>5. Data Transfers</h2>
          <p>
            Your personal data may be transferred to the following parties to the extent necessary to fulfill the above purposes and only with your explicit consent:
          </p>
          <ul>
            <li>Authorized public institutions and organizations when legally required</li>
            <li>Our service providers and business partners (data processors)</li>
            <li>Investors and funding providers (only with your explicit consent)</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>6. Data Security</h2>
          <div className="security-container">
            <div className="security-icon-container">
              <FaLock className="security-icon" />
            </div>
            <div className="security-content">
              <p>
                We implement the following technical and organizational measures to ensure the security of your personal data:
              </p>
              <ul>
                <li>SSL encryption technology</li>
                <li>Data access authorization controls</li>
                <li>Regular security assessments</li>
                <li>Privacy training for our employees</li>
                <li>Data breach response procedures</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="privacy-section">
          <h2>7. Retention Period</h2>
          <p>
            Your personal data will be retained for as long as necessary for the purposes for which it was collected and in accordance with legal retention periods. When these periods expire, your data will be deleted, destroyed, or anonymized.
          </p>
        </div>

        <div className="privacy-section">
          <h2>8. Your Rights</h2>
          <p>Under the GDPR, you have the following rights:</p>
          <ul>
            <li>Right to be informed whether your personal data is being processed</li>
            <li>Right to access your personal data</li>
            <li>Right to know the purposes of processing and whether your data is used in accordance with these purposes</li>
            <li>Right to know the third parties to whom your data is transferred</li>
            <li>Right to request rectification of incomplete or inaccurate data</li>
            <li>Right to request erasure or deletion of your personal data</li>
            <li>Right to object to the processing of your data by automated means that produces legal effects or similarly significantly affects you</li>
            <li>Right to withdraw your consent at any time</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>9. Contact Information</h2>
          <div className="contact-container">
            <div className="contact-icon-container">
              <FaEnvelope className="contact-icon" />
            </div>
            <div className="contact-content">
              <p>
                For any requests regarding your personal data, please contact us at:
              </p>
              <p><strong>Email:</strong> hello@salptech.com</p>
              <p><strong>Address:</strong> Medeniyet Technopark | Ünalan Street D-100 Highway Side Road 34700 Üsküdar/İstanbul</p>
            </div>
          </div>
        </div>

        <div className="privacy-section">
          <h2>10. Policy Changes</h2>
          <p>
            We may update this Privacy Policy at any time. Updates will take effect when published on the Investor Startup Driver platform. We will notify you of any significant changes. You can stay informed about changes by regularly visiting this page.
          </p>
        </div>

       
      </div>
    </div>
  );
};

export default PrivacyPolicy;